import React from "react";
import { useDispatch } from "react-redux";
import { Link, Typography } from "@material-ui/core";
import { useFormik } from "formik";
import moment from "moment";
import { searchData, AddData } from "src/app-redux/common-actions";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { getOrderStatusAction } from "src/app-redux/work-order/actions/workorderActions";
import { IInvoicesItem } from "src/common/typings/invoices";
import { getLocalDateTime, getUTCDateTime } from "src/common/utils/app.util";
import UseWindowDimensions from "src/common/utils/getWindowDimensions";
import { moneyformatter } from "src/common/utils/helpers";
import CommonDataGridPage from "src/components/CommonDataGridPage/CommonDataGridPage";
import CommonDrawer from "src/components/CommonDrawer/CommonDrawer";
import CommonXGrid from "src/components/CommonXGrid/CommonXGrid";
import { Sticky } from "./stickyinfo";

export default function InvoicesList() {
  const dispatch = useDispatch();
  const [loader, setLoader] = React.useState(false);
  const [gData, setGData] = React.useState<IInvoicesItem[]>([]);
  const [drawerStatus, setdrawerStatus] = React.useState<boolean>(false);
  const [selectedData, setSelectedData] = React.useState<any>({});
  const columns = [
    {
      field: "id",
      headerName: "ID",
      type: "number",
      width: 100,
      renderCell: function customCell1(params: any) {
        return (
          <Link
            component="button"
            variant="body2"
            onClick={() => {
              if (!params.row.qpExclude) {
                isDrawerOpen(params.row);
              } else {
                dispatch(
                  addNotificationAction({
                    message: "Quickpay is disabled for your company. Please contact NJS support.",
                    options: { variant: "warning" },
                  })
                );
              }
            }}
          >
            {params.value}
          </Link>
        );
      },
    },
    {
      field: "invoiceNum",
      headerName: "Invoice #",
      type: "string",
      width: 150,
    },
    {
      field: "payAmt",
      headerName: "Pay Amt",
      type: "number",
      width: 150,
      valueFormatter: (params: any) => {
        if (!params.value) {
          return params.value;
        }
        return moneyformatter(params.value);
      },
    },
    {
      field: "invoiceAmt",
      headerName: "Invoice Amt",
      type: "number",
      width: 150,
      valueFormatter: (params: any) => {
        if (!params.value) {
          return params.value;
        }
        return moneyformatter(params.value);
      },
    },
    {
      field: "expectedDate",
      headerName: "Due Date",
      width: 150,
      type: "date",
    },
    {
      field: "recievedDate",
      headerName: "Invoice Date",
      width: 170,
      type: "date",
    },
    {
      field: "qpAmount",
      headerName: "QuickPay Amt",
      type: "number",
      width: 150,
      valueFormatter: (params: any) => {
        if (!params.value) {
          return params.value;
        }
        return moneyformatter(params.value);
      },
    },
    {
      field: "qpPercent",
      headerName: "QuickPay %",
      type: "number",
      width: 150,
    },
  ];
  React.useEffect(() => {
    dispatch(getOrderStatusAction());
  }, []);

  const formik = useFormik({
    initialValues: {
      status: "Unpaid",
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
    },
    onSubmit: (values) => {
      alert(JSON.stringify(values, null, 2));
    },
  });

  const { values, setValues } = formik;

  const handleSearch = async () => {
    const { status, startDate, endDate } = values;
    const body = {
      status: status || "",
      startDate: startDate || null,
      endDate: endDate || null,
    };
    setGData([]);
    setLoader(true);
    try {
      const results: any = await dispatch(
        searchData("/get-vendor-invoices-unpaid-for-quick-pay", JSON.stringify(body))
      );
      if (results?.vendorInvoices) {
        const transformedData = results.vendorInvoices.map((invoice: any) => {
          return {
            ...invoice,
            expectedDate: getLocalDateTime(invoice.expectedDate, "MM/DD/YYYY"),
            recievedDate: getLocalDateTime(invoice.recievedDate, "MM/DD/YYYY"),
          };
        });
        setGData(transformedData);
      }
    } catch (error) {
      setLoader(false);
    }

    setLoader(false);
  };

  const isDrawerOpen = (parms: any) => {
    setSelectedData(parms);
    setdrawerStatus(true);
  };
  const submitForm = async (item: any) => {
    setdrawerStatus(false);
    setLoader(true);
    const body = {
      id: selectedData.id,
      percentage: item.per,
      Amount: parseFloat(item.payAmt),
      // dueDate: item.payDate.toISOString() || "",
      // dueDate: item.payDate.format("MM/DD/YYYY") || "",
      dueDate: getUTCDateTime(item?.payDate?.format("YYYY-MM-DD")) || "",
    };

    try {
      await dispatch(
        AddData(
          "/update-vendor-inv-head-quick-pay",
          "Quick Pay added successfully",
          JSON.stringify(body)
        )
      );
      handleSearch();
    } catch (error) {
      setLoader(false);
    }
    setLoader(false);
  };
  React.useEffect(() => {
    handleSearch();
  }, []);

  const { height } = UseWindowDimensions();
  let gridMaxHeight = 0;
  const dppr = 1000;
  gridMaxHeight = height - 260;
  return (
    <>
      <CommonDrawer
        heading={"QuickPay"}
        isOpen={drawerStatus}
        closeDrawer={() => {
          setdrawerStatus(false);
        }}
        drawerWidth={650}
      >
        <>
          <Sticky
            stickyInfo={selectedData}
            setdrawerStatus={() => setdrawerStatus(false)}
            submitForm={submitForm}
          />
        </>
      </CommonDrawer>
      <CommonDataGridPage
        module={"QuickPay"}
        heading={"List of QuickPay"}
        linkTo="quick-pay"
        GridDataComp={
          <CommonXGrid
            rows={gData}
            columns={columns}
            loader={loader}
            defaultPerPageRecord={dppr}
            height={gridMaxHeight}
            modifyColumns
          />
        }
      >
        <></>
      </CommonDataGridPage>
    </>
  );
}
